import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { DOWNLOAD_FILE } from 'framework/base/constants/aryRestCommands';
import useAryGetData, {
  aryGetDataExpectTypes
} from 'framework/base/hooks/useAryGetData';
import useAryLayoutType from 'framework/base/hooks/useAryLayoutType';
import { limitCharacters } from 'framework/base/utils/Utils';
import React, { useState } from 'react';
import { imageAddressPrefix } from 'spec';
import ActionButtons from './ActionButtons';
import {
  DownloadIcon,
  DownloadIconWrapper,
  img,
  thumb,
  thumbInner
} from './StyledComponents';

// ******************************** styled components ***********************************

const AryUploadedFileItems = ({
  // key,
  preview,
  previews,
  updatePreviewsAfterFileDownloaded,
  onShowPreview,
  files,
  prevFiles,
  propsFileIds,
  handleRemovedFileIds,
  removedFileIds,
  onChange,
  setPreviews,
  setPrevFiles,
  handleSavedFileIds,
  handleSetDisabledDropzone
}) => {
  // TODO: we should have overlay page when we should view the image file.
  // TODO: just image files have overlay and others should download after view request.
  // TODO: onClick set preview.
  const layoutType = useAryLayoutType();
  const [isItemHovered, setIsItemHovered] = useState(false);

  const [downloadFile, { loading: downloadFileLoading }] = useAryGetData(
    DOWNLOAD_FILE,
    {
      expect: aryGetDataExpectTypes.file
    }
  );
  // TODO: use theme instead of hex & RGB color codes
  const actionIconWrapperSx = {
    background:
      'linear-gradient(0deg, #566E88, #566E88),linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
    opacity: '0.6',
    '&:hover': {
      background:
        'linear-gradient(0deg, #566E88, #566E88),linear- gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),linear- gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
      opacity: '0.8'
    }
  };

  return (
    <Box
      sx={{ ...thumb(layoutType) }}
      key={preview.name}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <Box
        onMouseUp={() => {
          if (!preview.downloaded) return;
          if (
            preview.imgSrc === 'pdf' ||
            preview.imgSrc === 'docx' ||
            preview.imgSrc === 'xlsx'
          ) {
            onShowPreview(preview);
          }
        }}
        onMouseOver={() => {
          setIsItemHovered(true);
        }}
        onMouseOut={() => {
          setIsItemHovered(false);
        }}
        sx={thumbInner(
          preview.imgSrc === 'pdf' ||
            preview.imgSrc === 'docx' ||
            preview.imgSrc === 'xlsx',
          layoutType,
          preview.downloaded
        )}
      >
        {preview.downloaded ? (
          <>
            <img
              src={
                preview.imgSrc === 'pdf' || preview.filePreview === 'pdf'
                  ? `${imageAddressPrefix}static/img/icons/pdf.png`
                  : preview.imgSrc === 'docx'
                  ? `${imageAddressPrefix}static/img/icons/word.png`
                  : preview.imgSrc === 'xlsx'
                  ? `${imageAddressPrefix}static/img/icons/excel.png`
                  : preview.imgSrc
              }
              style={img(
                preview.imgSrc === 'pdf' ||
                  preview.imgSrc === 'docx' ||
                  preview.imgSrc === 'xlsx',
                layoutType
              )}
              alt="file preview"
            />
            {isItemHovered && (
              <ActionButtons
                preview={preview}
                previews={previews}
                files={files}
                prevFiles={prevFiles}
                propsFileIds={propsFileIds}
                removedFileIds={removedFileIds}
                handleRemovedFileIds={handleRemovedFileIds}
                onChange={onChange}
                setPreviews={setPreviews}
                setPrevFiles={setPrevFiles}
                handleSavedFileIds={handleSavedFileIds}
                style={{
                  position: 'absolute',
                  bottom: '.2rem',
                  left: '.2rem'
                }}
                iconSx={actionIconWrapperSx}
                handleSetDisabledDropzone={handleSetDisabledDropzone}
              />
            )}
          </>
        ) : downloadFileLoading ? (
          <CircularProgress size={20} />
        ) : (
          <DownloadIconWrapper
            onMouseUp={() => {
              downloadFile([{ key: 'fileId', value: preview.fileId }]).then(
                (downloadFileData) => {
                  updatePreviewsAfterFileDownloaded(preview, downloadFileData);
                }
              );
            }}
          >
            <DownloadIcon />
          </DownloadIconWrapper>
        )}
      </Box>
      <Grid
        item
        maxWidth="4.5rem"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
      >
        <Typography variant="h7Bold">
          {limitCharacters(preview.name, 35)}
        </Typography>
      </Grid>
    </Box>
  );
};

export default AryUploadedFileItems;
